module.exports = __webpack_public_path__ + "img/StudioLight-StillLife.af7bdd4f.jpeg";